module.exports = window["Bernie_l10nBundle_es_EC"];